import { render, staticRenderFns } from "./AddArticlesSubSections.vue?vue&type=template&id=376f0112&scoped=true&"
import script from "./AddArticlesSubSections.vue?vue&type=script&lang=js&"
export * from "./AddArticlesSubSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f0112",
  null
  
)

export default component.exports